export default __webpack_public_path__ + "static/media/cat.18b1376f.svg";